// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.privacy-container {
  margin-top: 1vw;
  margin-left: 4vw;
  padding: 1.5rem;
  max-width: 1800px;
  width: 90%;
  box-sizing: border-box;
}

.privacy-content {
  padding: 0 0px;
}

.privacy-header-row {
  margin-top: 5px;
}

.card-item {
  padding: 10px 0;
  background: #fff;
  border-radius: 10px;
  box-shadow: 2px 2px 30px #0000000d;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  max-width: 350px;
  margin: 0px;
  max-height: 130px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.card-item-icon {
  margin-bottom: 8px;
}

.card-item-text {
  font-size: 14px;
}
.privarcypolicy-card-text {
  display: flex;
  font-size: 16px;
  color: black;
}

@media (max-width: 1024px) {
  .privacy-container {
    margin: 0rem auto;
    padding: 1.5rem;
    max-width: 1400px;
    width: 95%;
  }
  .privarcypolicy-card-text {
    display: flex;
    padding-left: 1vh;
    font-size: 12px;
    color: black;
  }
  .card-item {
    padding: 8px 0;
  }
}
@media (max-width: 768px) {
  .privacy-container {
    margin: 0rem auto;
    padding: 0rem 1.5rem;
    width: 95%;
  }
  .privacy-header-row {
    margin-top: 21px;
  }
  .privacy-content {
    padding: 0;
  }
}
@media (max-width: 480px) {
  .privacy-container {
    margin: 0rem auto;
    padding: 0rem 1rem;
    width: 100%;
  }
  .privacy-content {
    padding: 0;
  }
  .card-item {
    padding: 0px 0px 0px 0px;
    height: 100%;
    min-height: 60px;
    background: #fff;
    border-radius: 10px;
    box-shadow: 2px 2px 30px #0000000d;
  }
}
/* Media query for very small screens (320px) */
@media (max-width: 360px) {
  .privacy-container {
    margin: 1.5rem auto;
    padding: 0.8rem;
    width: 100%;
    font-size: 0.5rem;
  }
  .card-item-text {
    font-size: 12px !important;
  }
  .ant-card .ant-card-body {
    padding: 18px;
    border-radius: 0 0 8px 8px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/layout/privacypolicies/PrivacyAndPolicies.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;EAClC,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,qDAAqD;AACvD;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE;IACE,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,UAAU;EACZ;EACA;IACE,aAAa;IACb,iBAAiB;IACjB,eAAe;IACf,YAAY;EACd;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,iBAAiB;IACjB,oBAAoB;IACpB,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,kCAAkC;EACpC;AACF;AACA,+CAA+C;AAC/C;EACE;IACE,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,aAAa;IACb,0BAA0B;EAC5B;AACF","sourcesContent":[".privacy-container {\n  margin-top: 1vw;\n  margin-left: 4vw;\n  padding: 1.5rem;\n  max-width: 1800px;\n  width: 90%;\n  box-sizing: border-box;\n}\n\n.privacy-content {\n  padding: 0 0px;\n}\n\n.privacy-header-row {\n  margin-top: 5px;\n}\n\n.card-item {\n  padding: 10px 0;\n  background: #fff;\n  border-radius: 10px;\n  box-shadow: 2px 2px 30px #0000000d;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n  max-width: 350px;\n  margin: 0px;\n  max-height: 130px;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n.card-item-icon {\n  margin-bottom: 8px;\n}\n\n.card-item-text {\n  font-size: 14px;\n}\n.privarcypolicy-card-text {\n  display: flex;\n  font-size: 16px;\n  color: black;\n}\n\n@media (max-width: 1024px) {\n  .privacy-container {\n    margin: 0rem auto;\n    padding: 1.5rem;\n    max-width: 1400px;\n    width: 95%;\n  }\n  .privarcypolicy-card-text {\n    display: flex;\n    padding-left: 1vh;\n    font-size: 12px;\n    color: black;\n  }\n  .card-item {\n    padding: 8px 0;\n  }\n}\n@media (max-width: 768px) {\n  .privacy-container {\n    margin: 0rem auto;\n    padding: 0rem 1.5rem;\n    width: 95%;\n  }\n  .privacy-header-row {\n    margin-top: 21px;\n  }\n  .privacy-content {\n    padding: 0;\n  }\n}\n@media (max-width: 480px) {\n  .privacy-container {\n    margin: 0rem auto;\n    padding: 0rem 1rem;\n    width: 100%;\n  }\n  .privacy-content {\n    padding: 0;\n  }\n  .card-item {\n    padding: 0px 0px 0px 0px;\n    height: 100%;\n    min-height: 60px;\n    background: #fff;\n    border-radius: 10px;\n    box-shadow: 2px 2px 30px #0000000d;\n  }\n}\n/* Media query for very small screens (320px) */\n@media (max-width: 360px) {\n  .privacy-container {\n    margin: 1.5rem auto;\n    padding: 0.8rem;\n    width: 100%;\n    font-size: 0.5rem;\n  }\n  .card-item-text {\n    font-size: 12px !important;\n  }\n  .ant-card .ant-card-body {\n    padding: 18px;\n    border-radius: 0 0 8px 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
